exports.dutch = require('./dutch').dutch
exports.english = require('./english').english
exports.french = require('./french').french
exports.german = require('./german').german
exports.spanish = require('./spanish').spanish
exports.italian = require('./italian').italian
